var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_345",
    "data-name": "Group 345",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225.297,
    height: 73.697,
    viewBox: "0 0 225.297 73.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 225.297,
    height: 73.697,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M38.365,35.392v46.1a1.016,1.016,0,0,0,.624,1.055L63.531,58.209,39.194,34.077a1.224,1.224,0,0,0-.829,1.315",
    transform: "translate(-38.365 -34.077)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.672,
    y1: 1.211,
    x2: -0.654,
    y2: 1.211,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0067a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#3e92a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#74b7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c6b1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M40.248,34.018,64.585,58.15l6.76-6.7L61.186,45.583l-.117-.067,0,0-.016-.01h0l-.01-.006-.007,0-.008,0h0l-.011-.006h0L61,45.473h0L41.555,34.248a2,2,0,0,0-.958-.276,1.283,1.283,0,0,0-.348.046",
    transform: "translate(-40.248 -33.972)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.57,
    y1: 2.429,
    x2: -0.556,
    y2: 2.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50b09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e486"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M39.782,113.2a1.336,1.336,0,0,0,1.066-.176l3.464-2,16.412-9.476.033-.019.019-.011h0l.019-.011,0,0,.024-.014.015-.009,0,0,.069-.04h0l.014-.008,10.158-5.865-6.759-6.7Z",
    transform: "translate(-39.782 -88.862)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.56,
    y1: 1.415,
    x2: -0.546,
    y2: 1.415,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc1b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#c1203b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#8a2b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753080"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M95.5,80.348l6.759,6.7h0l.071-.041.006,0h0l.021-.012.018-.01,0,0,.024-.014.014-.008.024-.014.006,0,.021-.012.039-.022.015-.009.007,0,.006,0,7.116-4.108.056-.033.027-.015,2.3-1.329c1.084-.636,1.021-1.494.159-2.019l-.093-.053-.015-.008c-.967-.521-9.834-5.677-9.834-5.677Z",
    transform: "translate(-95.498 -73.646)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.387,
    y1: 3.077,
    x2: -2.362,
    y2: 3.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#eb7164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#f9a85e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbe5c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M225.3,63.737a9.959,9.959,0,0,1-9.957,9.96H9.959A9.961,9.961,0,0,1,0,63.737V9.959A9.96,9.96,0,0,1,9.959,0H215.34A9.959,9.959,0,0,1,225.3,9.959Z",
    fill: "#161615"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(16.899 15.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 25.166,
    height: 48.467,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(17.728 14.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 31.096,
    height: 24.178,
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(17.523 39.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 31.301,
    height: 24.433,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(42.065 32.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 17.625,
    height: 13.405,
    fill: "url(#linear-gradient-4)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M389.48,91.9a6.273,6.273,0,0,1-2.589-.523,4.87,4.87,0,0,1-1.967-1.609h-.159a19.507,19.507,0,0,1,.159,2.41v5.972h-2.2V77.122h1.787l.3,1.987h.106a5.109,5.109,0,0,1,1.974-1.721,6,6,0,0,1,2.582-.53,5.364,5.364,0,0,1,4.456,1.973,8.688,8.688,0,0,1,1.569,5.536,8.646,8.646,0,0,1-1.595,5.556A5.377,5.377,0,0,1,389.48,91.9m-.318-13.177a3.9,3.9,0,0,0-3.218,1.232,6.342,6.342,0,0,0-1.02,3.92v.49a7.262,7.262,0,0,0,1.02,4.377,3.879,3.879,0,0,0,3.271,1.317,3.4,3.4,0,0,0,2.948-1.522,7.221,7.221,0,0,0,1.066-4.2,6.953,6.953,0,0,0-1.066-4.165,3.508,3.508,0,0,0-3-1.45",
    transform: "translate(-214.143 -43.003)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 2.198,
    height: 20.606,
    transform: "translate(184.254 28.027)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M439.268,91.67,438.83,89.6h-.106a6.084,6.084,0,0,1-2.165,1.847,6.58,6.58,0,0,1-2.694.484,4.85,4.85,0,0,1-3.384-1.112,4.056,4.056,0,0,1-1.225-3.165q0-4.4,7.032-4.609l2.464-.079v-.9a3.676,3.676,0,0,0-.736-2.523,3.021,3.021,0,0,0-2.35-.814,9.573,9.573,0,0,0-4.106,1.112l-.676-1.682a10.337,10.337,0,0,1,2.351-.914,10.178,10.178,0,0,1,2.562-.331,5.529,5.529,0,0,1,3.848,1.152,4.813,4.813,0,0,1,1.251,3.695V91.67ZM434.3,90.12a4.464,4.464,0,0,0,3.224-1.125,4.166,4.166,0,0,0,1.173-3.153V84.532l-2.2.092a8,8,0,0,0-3.781.816,2.456,2.456,0,0,0-1.158,2.245,2.261,2.261,0,0,0,.722,1.813,2.993,2.993,0,0,0,2.02.623",
    transform: "translate(-240.177 -43.037)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M458.581,77.459h2.357l3.178,8.277a31.648,31.648,0,0,1,1.3,4.093h.106q.172-.677.722-2.312t3.6-10.057h2.358l-6.238,16.527a8.243,8.243,0,0,1-2.166,3.477,4.6,4.6,0,0,1-3.038,1.025,8.869,8.869,0,0,1-1.987-.225V96.5a7.647,7.647,0,0,0,1.629.159q2.265,0,3.231-2.543l.807-2.065Z",
    transform: "translate(-256.585 -43.34)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M291.225,79.132a5.119,5.119,0,0,1,2.154,4.1c0,2.245-1.275,3.31-2.55,4.31a2.136,2.136,0,0,0-.85,1.489,1.666,1.666,0,0,0,.79,1.3l1.094.848c1.336,1.123,2.549,2.156,2.549,4.252,0,2.853-2.763,5.736-7.983,5.736-4.4,0-6.527-2.094-6.527-4.342a4.368,4.368,0,0,1,2.337-3.7,13.088,13.088,0,0,1,5.8-1.4,3.177,3.177,0,0,1-.911-2.062,2.744,2.744,0,0,1,.3-1.185c-.335.031-.668.061-.973.061a4.8,4.8,0,0,1-5.038-4.765,5.461,5.461,0,0,1,1.942-4.068,8.276,8.276,0,0,1,5.436-1.67h6.252l-1.943,1.093Zm-2.156,13.48a4.647,4.647,0,0,0-.7-.032,12.132,12.132,0,0,0-3.188.488,3.409,3.409,0,0,0-2.611,3.126c0,2.154,2.1,3.7,5.344,3.7,2.912,0,4.463-1.4,4.463-3.28,0-1.551-1-2.368-3.31-4.007m.881-5.769a3.07,3.07,0,0,0,.757-2.216c0-2.185-1.3-5.585-3.824-5.585a2.834,2.834,0,0,0-2.125,1,3.506,3.506,0,0,0-.669,2.246c0,2.034,1.184,5.4,3.8,5.4a3.107,3.107,0,0,0,2.065-.851",
    transform: "translate(-156.611 -43.664)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M252.827,91.578a7.152,7.152,0,0,1-7.395-7.154,7.51,7.51,0,0,1,7.852-7.364,7.085,7.085,0,0,1,7.242,7.153,7.406,7.406,0,0,1-7.7,7.365m3.788-2.454a5.483,5.483,0,0,0,.91-3.366c0-2.668-1.273-7.759-5.031-7.759a4.223,4.223,0,0,0-2.727,1.032,4.586,4.586,0,0,0-1.4,3.7c0,3,1.485,7.937,5.154,7.937a3.872,3.872,0,0,0,3.09-1.543",
    transform: "translate(-137.324 -43.117)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M215.531,91.578a7.152,7.152,0,0,1-7.4-7.154,7.511,7.511,0,0,1,7.851-7.364,7.085,7.085,0,0,1,7.243,7.153,7.406,7.406,0,0,1-7.7,7.365m3.789-2.454a5.491,5.491,0,0,0,.91-3.366c0-2.668-1.273-7.759-5.032-7.759a4.224,4.224,0,0,0-2.727,1.032,4.585,4.585,0,0,0-1.394,3.7c0,3,1.484,7.937,5.153,7.937a3.875,3.875,0,0,0,3.091-1.543",
    transform: "translate(-116.456 -43.117)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M176.21,82.388l-4.358,1.006a32.308,32.308,0,0,1-5.028.517c-8.411,0-11.609-6.186-11.609-11.031,0-5.911,4.539-11.394,12.311-11.394a17.559,17.559,0,0,1,4.661.64,11.89,11.89,0,0,1,4.022,1.889l-2.53,2.407-1.066.243.762-1.219a8.71,8.71,0,0,0-6.521-2.863c-4.815,0-8.441,3.658-8.441,8.99,0,5.727,4.145,11.121,10.786,11.121a9.074,9.074,0,0,0,3.871-.762V77.025l-4.6.244,2.437-1.312h6.461l-.792.762a.711.711,0,0,0-.305.487c-.032.275-.06,1.159-.06,1.464Z",
    transform: "translate(-86.846 -34.402)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M319.252,80.649c-1.006-.092-1.217-.274-1.217-1.463V61.938c.006-.066.011-.133.016-.2.123-1.066.427-1.249,1.373-1.8h-4.359l-2.286,1.1h2.33v.014l0-.011V79.856c0,.608-.121.7-.822,1.614h5.394l1.127-.668c-.518-.063-1.036-.092-1.555-.153",
    transform: "translate(-175.006 -33.54)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M341.594,90.518c-.332.182-.664.395-1,.545a7.052,7.052,0,0,1-2.938.575,6.465,6.465,0,0,1-4.025-1.18,7.833,7.833,0,0,1-3.085-6.386,6.858,6.858,0,0,1,6.93-6.99,5.884,5.884,0,0,1,3.119.847,5.01,5.01,0,0,1,2.116,2.994L335.6,83.8l-2.331.181c.755,3.843,3.358,6.08,6.234,6.08A7.819,7.819,0,0,0,343.2,89ZM338.75,81.5c.574-.211.877-.393.877-.817a3,3,0,0,0-3-2.6c-1.212,0-3.48.939-3.48,4.206,0,.514.061,1.059.092,1.606Z",
    transform: "translate(-184.949 -43.129)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M361.108,77.288v2h-.243v-2H360.2v-.207h1.564v.207Z",
    transform: "translate(-201.541 -43.128)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M366.321,79.285V77.27h-.011l-.615,2.015h-.19l-.62-2.015h-.008v2.015h-.22v-2.2h.378l.562,1.781h.008l.553-1.781h.383v2.2Z",
    transform: "translate(-204.033 -43.129)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M161.333,40.189h-1.514a10.035,10.035,0,0,0-.43-1.769H157.2a9.155,9.155,0,0,0-.445,1.769h-1.424q0-.184,1.1-3.028a23.719,23.719,0,0,0,1.1-3.132h1.789a26.07,26.07,0,0,0,1,3.087,27.077,27.077,0,0,1,1,3.073m-2.186-2.673a26.61,26.61,0,0,1-.809-2.64h-.076q0,.184-.837,2.64Z",
    transform: "translate(-86.912 -19.039)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M176.357,40.189h-1.169a11.549,11.549,0,0,0-1.3-2.049,11.276,11.276,0,0,1-1.552-2.674h-.076a16.683,16.683,0,0,1,.118,1.874q0,1.169.066,2.849H171.28q.071-1.467.071-3.223,0-1.727-.071-2.938h1.405a8.9,8.9,0,0,0,1.169,2,11.754,11.754,0,0,1,1.429,2.522h.071a17.854,17.854,0,0,1-.114-1.893q0-1.282-.067-2.631h1.183q-.067,1.173-.066,2.938t.066,3.223",
    transform: "translate(-95.834 -19.039)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M191.764,36.86a3.489,3.489,0,0,1-.862,2.347,3.007,3.007,0,0,1-2.413,1q-.7,0-1.931-.057.061-1.429.062-3.223,0-1.722-.062-2.939h.828c.136,0,.337,0,.606-.014s.443-.014.525-.014a3.19,3.19,0,0,1,2.477.851,2.946,2.946,0,0,1,.769,2.045m-1.292.2a2.284,2.284,0,0,0-.53-1.532,2.011,2.011,0,0,0-1.618-.622,5.037,5.037,0,0,0-.559.043q.048.947.048,1.978,0,1.131.047,2.243a3.135,3.135,0,0,0,.615.062,1.788,1.788,0,0,0,1.507-.632,2.438,2.438,0,0,0,.49-1.54",
    transform: "translate(-104.383 -19.004)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M206.4,40.152H205a9.332,9.332,0,0,0-.842-2.068,1.105,1.105,0,0,0-.947-.392c-.183,0-.358,0-.525,0q0,1.216.042,2.456H201.41q.061-1.429.062-3.223,0-1.722-.062-2.938h.818q.142,0,.594-.014t.835-.014q2.172,0,2.172,1.486a1.667,1.667,0,0,1-1.24,1.642v.071a1.476,1.476,0,0,1,.837.745,16.469,16.469,0,0,1,.97,2.246M204.623,35.8q0-.942-1.211-.942a4.118,4.118,0,0,0-.785.067q.052.733.052,1.911.26.01.44.01,1.5,0,1.5-1.046",
    transform: "translate(-112.693 -19.003)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M220.479,36.814a3.4,3.4,0,0,1-.889,2.409,2.885,2.885,0,0,1-2.2.956A2.782,2.782,0,0,1,215.3,39.3a3.09,3.09,0,0,1-.842-2.231,3.4,3.4,0,0,1,.89-2.409,2.886,2.886,0,0,1,2.2-.956,2.784,2.784,0,0,1,2.091.875,3.091,3.091,0,0,1,.842,2.233m-1.306.137a2.441,2.441,0,0,0-.506-1.6,1.56,1.56,0,0,0-1.249-.615,1.443,1.443,0,0,0-1.173.62,2.472,2.472,0,0,0-.482,1.566,2.435,2.435,0,0,0,.509,1.6,1.557,1.557,0,0,0,1.247.618,1.442,1.442,0,0,0,1.173-.622,2.476,2.476,0,0,0,.482-1.564",
    transform: "translate(-119.992 -18.859)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M232.5,40.189h-1.339q.061-1.467.062-3.223,0-1.727-.062-2.938H232.5q-.061,1.192-.062,2.938,0,1.785.062,3.223",
    transform: "translate(-129.341 -19.039)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M243.163,36.86a3.489,3.489,0,0,1-.862,2.347,3.007,3.007,0,0,1-2.413,1q-.7,0-1.931-.057.061-1.429.062-3.223,0-1.722-.062-2.939h.828c.136,0,.337,0,.606-.014s.443-.014.525-.014a3.19,3.19,0,0,1,2.477.851,2.946,2.946,0,0,1,.769,2.045m-1.292.2a2.284,2.284,0,0,0-.53-1.532,2.011,2.011,0,0,0-1.618-.622,5.037,5.037,0,0,0-.559.043q.048.947.048,1.978,0,1.131.047,2.243a3.135,3.135,0,0,0,.615.062,1.788,1.788,0,0,0,1.507-.632,2.438,2.438,0,0,0,.49-1.54",
    transform: "translate(-133.142 -19.004)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M262.809,40.189h-1.514a10.01,10.01,0,0,0-.431-1.769h-2.186a9.154,9.154,0,0,0-.445,1.769h-1.424q0-.184,1.1-3.028a23.669,23.669,0,0,0,1.1-3.132h1.789a26.17,26.17,0,0,0,1,3.087,27.143,27.143,0,0,1,1,3.073m-2.186-2.673a26.694,26.694,0,0,1-.81-2.64h-.076q0,.184-.837,2.64Z",
    transform: "translate(-143.69 -19.039)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M277.25,35.606a1.844,1.844,0,0,1-.84,1.67,3.732,3.732,0,0,1-2.061.54q-.222,0-.317-.01,0,.89.052,2.347h-1.33q.061-1.367.062-3.222,0-1.7-.062-2.938h.823q.175,0,.672-.014t.861-.014a2.708,2.708,0,0,1,1.519.407,1.377,1.377,0,0,1,.62,1.235m-1.221.26q0-1.012-1.344-1.013a3.819,3.819,0,0,0-.71.071q.052.895.052,2.025c.079.007.17.009.274.009q1.727,0,1.727-1.093",
    transform: "translate(-152.612 -19.004)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M290.135,35.606a1.844,1.844,0,0,1-.84,1.67,3.734,3.734,0,0,1-2.061.54q-.222,0-.317-.01,0,.89.052,2.347h-1.33q.061-1.367.062-3.222,0-1.7-.062-2.938h.824q.174,0,.672-.014t.861-.014a2.708,2.708,0,0,1,1.519.407,1.377,1.377,0,0,1,.62,1.235m-1.221.26q0-1.012-1.344-1.013a3.819,3.819,0,0,0-.71.071q.052.895.052,2.025c.079.007.17.009.274.009q1.727,0,1.727-1.093",
    transform: "translate(-159.821 -19.004)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M309.258,36.814a3.4,3.4,0,0,1-.89,2.409,2.884,2.884,0,0,1-2.2.956,2.78,2.78,0,0,1-2.091-.878,3.092,3.092,0,0,1-.842-2.231,3.4,3.4,0,0,1,.889-2.409,2.887,2.887,0,0,1,2.2-.956,2.785,2.785,0,0,1,2.091.875,3.091,3.091,0,0,1,.842,2.233m-1.306.137a2.441,2.441,0,0,0-.507-1.6,1.559,1.559,0,0,0-1.249-.615,1.444,1.444,0,0,0-1.174.62,2.475,2.475,0,0,0-.482,1.566,2.437,2.437,0,0,0,.509,1.6,1.559,1.559,0,0,0,1.247.618,1.441,1.441,0,0,0,1.173-.622,2.474,2.474,0,0,0,.483-1.564",
    transform: "translate(-169.665 -18.859)",
    fill: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M325.02,40.189h-1.169a11.54,11.54,0,0,0-1.3-2.049A11.287,11.287,0,0,1,321,35.466h-.076a16.683,16.683,0,0,1,.118,1.874q0,1.169.066,2.849h-1.164q.071-1.467.071-3.223,0-1.727-.071-2.938h1.405a8.921,8.921,0,0,0,1.169,2,11.755,11.755,0,0,1,1.429,2.522h.071a17.851,17.851,0,0,1-.114-1.893q0-1.282-.066-2.631h1.183q-.067,1.173-.066,2.938t.066,3.223",
    transform: "translate(-179.014 -19.039)",
    fill: "#fbfcfc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.6379807c95e0500c6a8080205f9e6c7f.svg";
export { ForwardRef as ReactComponent };